import React from 'react'
import styled from 'styled-components'
import visit_subheader_wrapperStyles from './visit_subheader_wrapper.styles'

const apAtomName = {ap_atom_name: 'apVisitSubheaderWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${visit_subheader_wrapperStyles}
`

const VisitSubHeaderWrapperAtom: React.FC = function (props) {
  return <StyledWrapper {...apAtomName} {...props} />
}

export default VisitSubHeaderWrapperAtom
